import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'dmmp-basic-page',
  templateUrl: './basic-page.component.html'
})
export class BasicPageComponent implements OnInit {
  @Input() module
  @Input() identifier
  @Input() detailLayout
  constructor() { }

  ngOnInit(): void {
  }

}
